import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";

import { Modal } from "../Modal";
import { useCopyHandler } from "./useCopyHandler";

import { IProps } from "./types";
import { SearchInput } from "../SearchInput";
import { Grid } from "../../UI/Grid";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Chip } from "../../UI/Chip";
import useAuth from "../../routes/login/AuthContext";

export const CopyQuestionsToOtherNetworks: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();
  const {
    l1,
    l2,
    l3,
    isNetworksLoading,
    networks,
    isLoading,
    handleUpdate,
    selectedNetworks,
    handleFocus,
    handleDeleteChip,
    searchValue,
    handleKeyDown,
    handleChange,
    handleNetworkSelect,
  } = useCopyHandler(props);

  const handleModalOpen = () => setIsOpen(true);

  return (
    <>
      <Button onClick={handleModalOpen} isDisabled={!props.l1Id || !props.l2Id || !props.l3Id || isSuperAdminRead() || props.editDisabled}>
        Apply to other networks
      </Button>
      <Modal
        maxWidth="sm"
        title="Apply Lifestyle Questions to Other Networks"
        actions={
          <Button appearance="primary" isLoading={isLoading} onClick={handleUpdate}>
            Update
          </Button>
        }
      >
        <Box minHeight={400} px={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography gutterBottom>
                By applying lifestyle questions for the current Networks-Subnetworks-Unit Type selection to the networks
                chosen below, any lifestyle questions in these networks will be overwritten.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography gutterBottom>
                Lifestyle questions will be applied to all matching groups in the networks. It is required that there
                are 0 users in the networks in order for this update to be completed.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography gutterBottom>
                You are applying lifestyle questions from{" "}
                <strong>
                  {l1?.l1Name} - {l2?.l2Name} - {l3?.name}
                </strong>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <SearchInput
                fullWidth
                label="Network"
                options={networks}
                value={searchValue}
                handleFocus={handleFocus}
                handleChange={handleChange}
                handleKeyDown={handleKeyDown}
                isLoading={isNetworksLoading}
                handleOptionSelect={handleNetworkSelect}
              />
            </Grid>
            <Grid item container spacing={1}>
              {selectedNetworks.map(({ id, name }) => (
                <Grid item key={id}>
                  <Chip color="primary" label={`${name} - ${id}`} onDelete={handleDeleteChip(id)} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
